<!-- 这是传入图片，当作背景的操作 -->
<template>
  <div :style="computedStyle" class="tx-item-container">
    <slot></slot>
  </div>
</template>
<script setup>
import config from '@img/config.json';
const { support_image, is_mobile } = inject('GlobalStore');
import px2vw from '@/utils/px2vw_v2';
// import px2vw from '@/utils/px2vw';
const props = defineProps({
  src: {
    type: String,
    required: true,
  },
  size: {
    type: Object,
    required: false,
  },
});
const bg = ref();
const computedStyle = computed(() => {
  var size = null;
  if (props.size) {
    size = props.size;
  } else {
    size = config[props.src];
  }
  if (!size) {
    return {}
  }

  return {
    backgroundImage: `url(${bg.value})`,
    backgroundRepeat:'round',
    width: px2vw(size.width, is_mobile.value),
    height: px2vw(size.height, is_mobile.value),
  };
});

onMounted(async () => {
  let src = config[props.src]?.src;
  bg.value = `${src}.${support_image.value}`;
});
</script>
